/**
 * 平台用户账户 API — GET /api/accounts。
 * admin 看全部用户账户，user 只看自己。
 */
import client from "./client";
import type { Account } from "../types";

/** 获取平台用户账户列表。 */
export async function getAccounts(): Promise<Account[]> {
  return client.get<unknown, Account[]>("/accounts");
}

/** 配额调整响应（PATCH /api/admin/accounts/{id}/limits）。 */
export interface AccountLimitsUpdateResult {
  account_id: string;
  account_name: string;
  max_companies: number;
  max_products: number;
  company_count: number;
  product_count: number;
}

/** 调整账户公司/产品配额（仅 admin）。 */
export async function updateAccountLimits(
  accountId: string,
  limits: { max_companies: number; max_products: number },
): Promise<AccountLimitsUpdateResult> {
  return client.patch<unknown, AccountLimitsUpdateResult>(
    `/admin/accounts/${accountId}/limits`,
    limits,
  );
}
